import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Regex, RegexExtra, Validate } from '../../other';
import {
  tiendaObtener,
  tiendaActualizarApagarTemporalmente,
} from '../../store/actions';
import { Grid } from '@material-ui/core';
import { AlertUI, ModuleTitleUI, ButtonUI } from '../common';
import { ModalApagar, ModalEncender } from './subcomponents';
import {
  on_off_store_amplitude_events,
  createAmplitudeEventWithDevice,
} from '../amplitude';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class ApagarTemporalmente_ extends Component {
  state = {
    apagar_temporalmente: {
      t_offmode_mensaje: {
        auth: true,
        validate: true,
        required: false,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Mensaje para tus clientes',
        id: 't_offmode_mensaje',
        name: 't_offmode_mensaje',
        change_param: 'apagar_temporalmente',
        regex: Regex.DESCRIPCION_0_200,
        value: '',
        default_value: '',
        placeholder: 'Estaremos cerrados hasta el ....',
        messages: {
          error: 'Por favor, ingrese un mensaje válido',
          error_extra: RegexExtra.DESCRIPCION_0_200,
        },
      },
    },
    loading: {
      apagar_temporalmente: true,
      error: false,
    },
    forms: {
      apagar_temporalmente_apagar: false,
      apagar_temporalmente_encender: false,
    },
    modals: {
      apagar_temporalmente_apagar: false,
      apagar_temporalmente_encender: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    this.props.tiendaObtener((err, resp) => {
      if (err) {
        this.setState({
          loading: {
            ...this.state.loading,
            apagar_temporalmente: false,
            error: true,
          },
        });
      } else {
        Validate.cargar_formulario_sin_nulos(
          this.props.tienda,
          this.state.apagar_temporalmente,
          (apagar_temporalmente_obj) => {
            this.setState({
              apagar_temporalmente: apagar_temporalmente_obj,
              loading: {
                ...this.state.loading,
                apagar_temporalmente: false,
                error: false,
              },
            });
          }
        );
      }
    });
  }

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  modalHandler = (open, id, aditional) => {
    this.setState({
      modals: {
        ...this.state.modals,
        [id]: open,
      },
    });
  };

  handleSubmitApagar = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        apagar_temporalmente_apagar: true,
      },
    });

    let form = this.state.apagar_temporalmente;

    if (Validate.validar_formulario(form)) {
      this.props.tiendaActualizarApagarTemporalmente(
        {
          t_offmode_mensaje: form.t_offmode_mensaje.value,
          t_offmode: 1,
        },
        (err, resp) => {
          if (err) {
            this.setState({
              forms: {
                ...this.state.forms,
                apagar_temporalmente_apagar: false,
              },
              alert: {
                ...this.state.alert,
                open: true,
                message: resp.message,
                type: 'error',
              },
            });
          } else {
            this.setState(
              {
                forms: {
                  ...this.state.forms,
                  apagar_temporalmente_apagar: false,
                },
                alert: {
                  ...this.state.alert,
                  open: true,
                  message: resp.message,
                  type: 'success',
                },
                modals: {
                  ...this.state.modals,
                  apagar_temporalmente_apagar: false,
                },
              },
              () => {
                createAmplitudeEventWithDevice(
                  on_off_store_amplitude_events
                    .mi_tienda_selecciona_apagar_tienda_panel.event_name,
                  on_off_store_amplitude_events
                    .mi_tienda_selecciona_apagar_tienda_panel.event_params
                );
              }
            );
          }
        }
      );
    } else {
      Validate.validar_formulario_actualizar_obj(form, (new_form) => {
        this.setState({
          forms: {
            ...this.state.forms,
            apagar_temporalmente_apagar: false,
          },
          apagar_temporalmente: new_form,
        });
      });
    }
  };

  handleSubmitEncender = (e) => {
    e.preventDefault();

    this.setState(
      {
        forms: {
          ...this.state.forms,
          apagar_temporalmente_encender: true,
        },
      },
      () => {
        createAmplitudeEventWithDevice(
          on_off_store_amplitude_events
            .mi_tienda_selecciona_encender_tienda_panel.event_name,
          on_off_store_amplitude_events
            .mi_tienda_selecciona_encender_tienda_panel.event_params
        );
      }
    );

    let form = this.state.apagar_temporalmente;

    if (Validate.validar_formulario(form)) {
      this.props.tiendaActualizarApagarTemporalmente(
        {
          t_offmode_mensaje: form.t_offmode_mensaje.value,
          t_offmode: 0,
        },
        (err, resp) => {
          if (err) {
            this.setState({
              forms: {
                ...this.state.forms,
                apagar_temporalmente_encender: false,
              },
              alert: {
                ...this.state.alert,
                open: true,
                message: resp.message,
                type: 'error',
              },
            });
          } else {
            this.setState({
              forms: {
                ...this.state.forms,
                apagar_temporalmente_encender: false,
              },
              alert: {
                ...this.state.alert,
                open: true,
                message: resp.message,
                type: 'success',
              },
              modals: {
                ...this.state.modals,
                apagar_temporalmente_encender: false,
              },
            });
          }
        }
      );
    } else {
      Validate.validar_formulario_actualizar_obj(form, (new_form) => {
        this.setState({
          forms: {
            ...this.state.forms,
            apagar_temporalmente_encender: false,
          },
          apagar_temporalmente: new_form,
        });
      });
    }
  };

  render() {
    return (
      <WrapperLayout
        loading={this.state.loading.apagar_temporalmente}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <ModalApagar
          apagar_temporalmente={this.state.apagar_temporalmente}
          handleSubmit={this.handleSubmitApagar}
          handleChange={this.handleChange}
          modalHandler={this.modalHandler}
          modal_state={this.state.modals.apagar_temporalmente_apagar}
          form_state={this.state.forms.apagar_temporalmente_apagar}
        />
        <ModalEncender
          handleSubmit={this.handleSubmitEncender}
          handleChange={this.handleChange}
          modalHandler={this.modalHandler}
          modal_state={this.state.modals.apagar_temporalmente_encender}
          form_state={this.state.forms.apagar_temporalmente_encender}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <ModuleTitleUI
              title="Apagar temporalmente"
              subtitles={[
                'Con ésta función podrás apagar tu tienda temporalmente. Es ideal para cuando no puedas administrarla, por ejemplo cuando estás de vacaciones.',
                'Cuando la apagues, podrás definir un mensaje opcional que se va a visualizar en la tienda.',
                'Tené en cuenta que mientras la tienda se encuentre apagada no se podrán visualizar los productos.',
              ]}
              button={
                <ButtonUI
                  type="callf"
                  label={this.props.tienda.t_offmode ? 'Encender' : 'Apagar'}
                  fullWidth={false}
                  onClickFunc={() =>
                    this.modalHandler(
                      true,
                      this.props.tienda.t_offmode
                        ? 'apagar_temporalmente_encender'
                        : 'apagar_temporalmente_apagar'
                    )
                  }
                  isLoading={false}
                />
              }
            />
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tienda: state.tienda,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tiendaObtener: (callback) => dispatch(tiendaObtener(callback)),
    tiendaActualizarApagarTemporalmente: (data, callback) =>
      dispatch(tiendaActualizarApagarTemporalmente(data, callback)),
  };
};

export const ApagarTemporalmente = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApagarTemporalmente_);
